"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

// "Binary" search in a sorted array.
function _default(array, test) {
  if (array.length === 0) {
    return 0;
  }

  var min = 0;
  var max = array.length - 1;
  var guess;

  while (min <= max) {
    guess = Math.floor((max + min) / 2);
    var result = test(array[guess]);

    if (result === 0) {
      return guess;
    } else if (result < 0) {
      min = guess + 1;

      if (min > max) {
        return min;
      }
    } else {
      max = guess - 1;

      if (max < min) {
        return min;
      }
    }
  } // return -1
  // return min

}
//# sourceMappingURL=binarySearch.js.map